import React from 'react'
import { Menu, Dropdown } from 'antd'

class IssuesHistory extends React.Component {
  render() {
    const menu = (
      <Menu selectable={false}>
        <Menu.Item>
          <a href="javascript: void(0);">Current search</a>
        </Menu.Item>
        <Menu.Item>
          <a href="javascript: void(0);">Search history</a>
        </Menu.Item>
        <Menu.Divider />
        <span className="topbar__dropdownTitle">
          <strong>Opened</strong>
        </span>
        <Menu.Item>
          <a href="javascript: void(0);">
            <i className="topbar__dropdownMenuIcon icmn-checkmark" /> Project Manager...
          </a>
        </Menu.Item>
        <Menu.Item>
          <a href="javascript: void(0);">
            <i className="topbar__dropdownMenuIcon icmn-checkmark" /> Demon Profile
            iss...
          </a>
        </Menu.Item>
        <Menu.Item>
          <a href="javascript: void(0);">
            <i className="topbar__dropdownMenuIcon icmn-clock" /> Offer #45 Block...
          </a>
        </Menu.Item>
        <Menu.Item>
          <a href="javascript: void(0);">More...</a>
        </Menu.Item>
        <Menu.Divider />
        <span className="topbar__dropdownTitle">
          <strong>Filters</strong>
        </span>
        <Menu.Item>
          <a href="javascript: void(0);">My open offers</a>
        </Menu.Item>
        <Menu.Item>
          <a href="javascript: void(0);">My search profiles</a>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <a href="javascript: void(0);">
            <i className="topbar__dropdownMenuIcon icmn-cog" /> Settings
          </a>
        </Menu.Item>
      </Menu>
    )
    return (
      <div className="topbar__dropdown d-inline-block mr-4">
        <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
          <a className="ant-dropdown-link" href="/">
            <i className="icmn-folder-open mr-2 topbar__dropdownIcon" />
            <span className="d-none d-xl-inline">
              <strong>Search History</strong>
            </span>
          </a>
        </Dropdown>
      </div>
    )
  }
}

export default IssuesHistory



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/IssuesHistory/index.js